import { render, staticRenderFns } from "./address-info.vue?vue&type=template&id=da4a8824&scoped=true&"
import script from "./address-info.vue?vue&type=script&lang=js&"
export * from "./address-info.vue?vue&type=script&lang=js&"
import style0 from "./address-info.vue?vue&type=style&index=0&id=da4a8824&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4a8824",
  null
  
)

export default component.exports